export const PROCESS_STEPS = [
    {
        title: 'Ontwerpen',
        text: "Stel uw deur samen in onze 3D-configurator. Kies model, maten, glasverdeling, glas, RAL-kleur en greep en zie direct wat het kost."
    },
    {
        title: 'Offerte of bestellen',
        text: "Download een uitgewerkte offerte als PDF of bestel direct. Twijfelt u nog? Bewaar uw ontwerpen in uw account."
    },
    {
        title: 'Aanbetaling',
        text: "U ontvangt meteen de orderbevestiging met het aanbetalingsformulier van 50%. Het restant betaalt u pas na plaatsing."
    },
    {
        title: 'Inmeten aan huis',
        text: "Onze specialist meet de opening tot op de millimeter in, bekijkt de vloer en de wand en legt de productiematen vast."
    },
    {
        title: 'Productie',
        text: "Uw deur wordt met de hand gelast, geschuurd en gepoedercoat. In uw account volgt u elke stap."
    },
    {
        title: 'Montage',
        text: "Onze eigen monteurs plaatsen uw deur, stellen hem perfect af en laten alles netjes achter."
    }
]

export const FAQ_ITEMS = [
    {
        question: 'Wat kost een stalen binnendeur?',
        answer: "Wij rekenen per vierkante meter, afhankelijk van het model. Daarbij komen alleen uw keuzes voor glas, kleur, greep en opties. De glasverdeling is altijd inbegrepen. In onze 3D-configurator ziet u bij elke keuze direct de prijs, inclusief btw, inmeten, bezorging en montage. Geen verrassingen achteraf."
    },
    {
        question: 'Kan ik de roeden zelf plaatsen?',
        answer: "Ja. Kies een vaste glasverdeling of zet elke roede in de configurator precies op de plek die u wilt, in millimeters. Horizontale roeden meet u vanaf de vloer, verticale vanaf de zijkant van het deurblad. Elke verdeling is bij de prijs inbegrepen."
    },
    {
        question: 'Kunnen jullie ook de oude binnendeur er uithalen en bezetten?',
        answer: "Ja, dit doen we standaard als service. We bespreken het zeker tijdens het huisbezoek en u krijgt er meteen een prijs voor."
    },
    {
        question: 'Moet ik zelf de maten opmeten?',
        answer: "Nee. In de configurator geeft u de maten bij benadering op. Na uw bestelling komt onze specialist bij u thuis exact inmeten. Pas daarna gaat uw deur in productie, zodat hij altijd perfect past."
    },
    {
        question: 'Hoe werkt de aanbetaling?',
        answer: "Na uw bestelling ontvangt u per e-mail een orderbevestiging met een aanbetalingsformulier van 50% van het totaalbedrag. Daarmee reserveren we uw plek in de productieplanning. Het restant voldoet u na plaatsing."
    },
    {
        question: 'Hoe lang duurt het voordat mijn deur geplaatst is?',
        answer: "De levertijd staat op uw offerte en orderbevestiging en gaat in na de definitieve inmeting. In uw persoonlijke klantomgeving ziet u op elk moment in welke fase uw deur zich bevindt."
    },
    {
        question: 'Welk glas kies ik voor de badkamer of slaapkamer?',
        answer: "Kies voor matglas. Dat laat veel licht door maar houdt inkijk tegen. Liever ribbelglas, rookglas of iets anders? Kies glas op aanvraag en beschrijf uw wens, dan sturen wij u een prijs. Al onze deuren zijn standaard voorzien van gelaagd veiligheidsglas."
    },
    {
        question: 'Wat is het verschil tussen een draaideur, taatsdeur en schuifdeur?',
        answer: "Een draaideur hangt aan scharnieren en draait naar één kant open. Een taatsdeur draait om een verticale as in de deur, waardoor hij extra breed en hoog kan zijn. Een schuifdeur glijdt langs de muur aan een stalen rail en neemt geen draairuimte in beslag."
    },
    {
        question: 'Kan ik mijn ontwerp bewaren of delen?',
        answer: "Ja. Met een gratis account bewaart u zoveel ontwerpen als u wilt en vraagt u offertes aan als PDF. Met de knop Delen in de configurator stuurt u een link naar uw ontwerp naar wie u maar wilt."
    }
]
